<template>
  <div id="removeclass">
    <app-modal
      :modal-id="modalId"
      :preloader="preloader"
      @close-modal="closeModal"
    >
      <template slot="header"> 
        <h5>{{modalTitle}}</h5>
      </template>
      <template slot="body">
        <app-overlay-loader v-if="preloader" />
        <el-form v-if="active === 1">
          <form
            class="mb-0"
            :class="{ 'loading-opacity': preloader }"
            ref="form"
            :data-url="addurl"
          >
            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="form-group">
                  <label for="inputs_category">{{ $t("category") }}</label>
                  <app-input
                    id="inputs_category"
                    type="search-select"
                    :placeholder="$t('select_category')"
                    v-model="formCategory"
                    :list="category"
                    :required="true"/>
                  <p class="font-italic text-muted">
                    {{ $t("shortcut_category_create") }} <span><a href="#" @click.prevent="addCategory()">{{$t("add_category")}}</a></span>
                  </p>
                </div>
              </div>
            </div>
            <div class="row" v-if="showQuestionnaire == true">
              <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="form-group">
                  <label>{{ $t("questionnaires") }}</label>
                  <app-input
                    type="multi-select"
                    :isAnimatedDropdown="true"
                    :placeholder="$t('forms')"
                    :list="this.forms"
                    v-model="inputs.form_id"
                    :required="true"
                  />
                  <p v-if="refreshShow == false" class="font-italic text-muted">
                    {{ $t("shortcut_questionnaire_create") }} <span><a href="#" @click.prevent="createForm()">{{$t("create_new")}}</a></span>
                  </p>
                  <p v-if="refreshShow == true" class="font-italic text-muted">
                    <a href="#" @click.prevent="refreshForm()">{{$t("refresh")}}</a><span> {{ $t("form_create_refresh") }}</span>                </p>
                </div>
              </div>
              <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="form-group">
                  <label>{{ $t("title") }}</label>
                  <app-input type="text" v-model="inputs.title"
                  :required="true" />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="form-group">
                  <label>{{ $t("description") }}</label>
                  <app-input
                    type="textarea"
                    id="textarea-id"
                    :label="$t('message_placeholder')"
                    v-model="inputs.description"
                    :required="true"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="form-group">
                  <label>{{ $t("start_date") }}</label>
                  <app-input
                    type="date"
                    v-model="inputs.start_date"
                    :required="true"
                    :placeholder="$t('select_valid_date')"
                  />
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12">
                <div class="form-group">
                  <label>{{ $t("due_date") }}</label>
                  <app-input
                    type="date"
                    v-model="inputs.due_date"
                    :required="true"
                    :placeholder="$t('select_valid_date')"
                  />
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 col-md-12 col-sm-12">
                <div class="form-group">
                  <label>{{ $t("priority") }}</label>
                  <app-input
                    type="radio"
                    :list="list"
                    v-model="inputs.priority"
                    :required="true"
                  />
                </div>
              </div>
            </div>
          </form>
        </el-form>
        <el-form v-if="active === 2"> 
          <documentlibrary-add-category :back='closeCategory'></documentlibrary-add-category>
        </el-form>
      </template>
      <template slot="footer" v-if="active == 1">
        <div class="row mt-2 text-right" >
          <div class="col-md-12">
              <button class="btn btn-secondary" @click="closeModal()">{{$t('cancel')}}</button>
              <button class="btn btn-primary" @click.prevent="submit()">{{$t('save')}}</button>
          </div>
        </div>
      </template>
    </app-modal>
  </div>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
import { ModalMixin } from "../../../../../app/Mixins/ModalMixin";
import { axiosPost, axiosGet } from "../../../../Helpers/AxiosHelper";
import AppLibrary from "../../../../Helpers/AppLibrary";
import {
  BUYER_CERTIFICATE_FORMS,
  PACKAGE_FORM_ASSIGN,
  QUESTIONNAIRE_FORM_LIST,
  CATEGORIES
} from "../../../../Config/ApiUrl";

export default {
  name: "AddModal",
  extends:AppLibrary,
  mixins: [FormMixin, ModalMixin],
  props: {
    id: Number,
  },
  data() {
    return {
      active: 1,
      showQuestionnaire: false,
      formCategory: '',
      category: [],
      refreshShow: false,
      addurl:PACKAGE_FORM_ASSIGN,
      preloader: false,
      inputs: {
        start_date: new Date(),
        due_date: new Date(),
      },
      forms: [],
      list: [
        {
          id: "High",
          value: "High",
        },
        {
          id: "Medium",
          value: "Medium",
        },
        {
          id: "Low",
          value: "Low",
        },
      ],
      modalId: "package-form-assign-Modal",
      modalTitle: this.$t("assign_form"),
    };
  },
  created() {
    if (this.selectedUrl) {
      this.modalTitle = this.$t("edit");
      this.preloader = true;
    }
  },
  watch: {
    formCategory() {
      this.getForms();
    }
  },
  methods: {
    addCategory() {
      this.modalTitle = 'Add Category';
      this.active = 2;
    },
    closeCategory(value) {
      this.title = this.$t("assign_form"),
      this.active = value;
      this.getCategories();
    },
    getCategories() {
      axiosGet(CATEGORIES)
        .then((res) => {
          this.category = res.data;
        })
        .catch((error) => {
          
        });
    },
    submit() {
      // this.preloader = true;
     
        this.inputs.type = 'package';
        this.inputs.package_id = this.id;
        if (this.inputs.start_date) this.inputs.start_date = this.getDateFormatForBackend(this.inputs.start_date);
        if (this.inputs.due_date) this.inputs.due_date = this.getDateFormatForBackend(this.inputs.due_date);
        // axiosPost(PACKAGE_FORM_ASSIGN, this.inputs)
        //   .then((res) => {
        //     
        //     this.$toastr.s(res.data.message);
        //   })
        //   .catch((error) => {
        //     
        //     this.$toastr.e(error);
        //   })
        //   .finally(() => {
        //     this.preloader = false;
        //     $("#package-form-assign-Modal").modal("hide");
        //   });
      this.save(this.inputs);
    },
    afterSuccess(response) {
      this.$toastr.s(response.data.message);
      this.$hub.$emit("reload-" + this.tableId);
    },

    afterSuccessFromGetEditData(response) {
      if (response.data.phone) this.phone = response.data.phone;
      this.inputs = response.data;
      this.preloader = false;
    },
    getForms() {
        let id = this.formCategory;
      axiosGet(QUESTIONNAIRE_FORM_LIST + id)
        .then((res) => {
          this.forms = res.data;
          this.showQuestionnaire = true;
        })
        .catch((error) => {
          
        });
    },
    refreshForm() {
      this.refreshShow = false;
      this.getForms();

    },
    createForm() {
      this.refreshShow = true;
      window.open('/admin/documentlibrary/myquestionnaire', '_blank');
    },
  },
  mounted() {
    this.getCategories();
    $(function () {
      $("#removeclass .modal-dialog ").removeClass("modal-dialog-scrollable");
    });
  },
};
</script>
